import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { ContactAutocompleteComponent } from '../contacts/contact-autocomplete/contact-autocomplete.component';
import {
  ContactAutocompleteService,
  ContactAutocompleteResult,
  ContactDetails,
} from '../services/contacts/contact-autocomplete.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { saveAs } from 'file-saver';
import { SearchOrAddTechnicianComponent } from '../modals/search-or-add-technician/search-or-add-technician.component';

// this is overkill, but this is also an experiment in "proper" coding
type Month = 'Jan' | 'Feb' | 'Mar' | 'Apr' | 'May' | 'Jun' | 'Jul' | 'Aug' | 'Sep' | 'Oct' | 'Nov' | 'Dec';
const MONTHS_MAPPING : Readonly<Record<Month, number>> = {
  'Jan': 1,
  'Feb': 2,
  'Mar': 3,
  'Apr': 4,
  'May': 5,
  'Jun': 6,
  'Jul': 7,
  'Aug': 8,
  'Sep': 9,
  'Oct': 10,
  'Nov': 11,
  'Dec': 12
} as const;

@Component({
  selector: 'app-jens-cool-component',
  templateUrl: './jens-cool-component.component.html',
  styleUrls: ['./jens-cool-component.component.scss']
})
export class JensCoolComponentComponent{
  constructor(private dialog: MatDialog, private http: HttpClient, private toastr: ToastrService) {}

  createReport(){
    const postUrl = `/api/financials/customer_financial_reports.php?contact_uuid=${this.customerContactUuid}`;
    const postBody = {
      ladings: this.ladingsToInclude,
      contact_uuid: this.customerContactUuid
    };

    this.creatingReport = true;
    this.http.post(postUrl, postBody, {responseType: 'blob'}).subscribe({
      next: blob => {
        this.creatingReport = false;
        const timestamp = new Date().toISOString().slice(0, 19).replace(/[:T]/g, '-');
        const filename = `${this.customerContactName}_invoice_${timestamp}.csv`;
        saveAs(blob, filename);
      },
      error: error => {
        this.creatingReport = false;
        this.showReportError(error);
      }
    })
  }

  showReportError(error: any){
    const fallback = `Could not create report${error?.status ? ` (${error.status})` : ''}.`;

    if (error?.error instanceof Blob) {
      const reader = new FileReader();
      reader.onload = () => {
        const text = String(reader.result || '').trim();
        this.toastr.error(this.extractReportErrorMessage(text) || fallback);
      };
      reader.onerror = () => this.toastr.error(fallback);
      reader.readAsText(error.error);
      return;
    }

    this.toastr.error(error?.error?.message || fallback);
  }

    private extractReportErrorMessage(text: string): string {
    if (!text) return '';

    try {
      const parsed = JSON.parse(text);
      return parsed?.message || parsed?.raw?.message || text;
    } catch {
      return text;
    }
  }

  customerContactName = 'Technogym_USA';
  creatingReport = false;
  customerContactUuid = 'b0c472a0-e85a-439a-9dbc-2ae40304a9f5'

  ladingsToInclude: string[] = [
'16847874-8b9b-4bad-ab80-e413b1a43e6b',
'00e978de-3bf5-431b-80c7-b4ac3a158fa9',
'43555fed-6e90-4edb-9bf1-bcecd84d1773',
'7baed650-9298-4f3d-8859-195d8502e7ea',
'38df32b2-e68d-4a35-80c3-ddd00b41075e',
'd15b4016-96a6-4e49-9fba-d6e7972f620e',
'76059415-8eb2-4d00-afb6-5808e167bfe0',
'24fd2d94-fdc3-479b-988d-5286a5c4344b',
'1565f17b-29e5-44cb-8462-c282b029ef5e',
'8feaa634-c559-4e8c-b72e-dfff17ef3598',
'3e82e275-dfe5-4ce1-93e3-a474967c1d32',
'5d07470e-4f37-4bbc-8943-520d970a2707',
'a091fa15-884c-4502-958f-4dded99224e5',
'4dc8dee5-7717-4174-b131-63d43552d7d2',
'39ee8f19-0c94-4558-a8c7-f025383f8419',
'db71123b-01a1-4f3c-bc91-a471aced5794',
'a8fa1b32-1519-4c7d-bc28-0262ecc937a0',
'606038d0-07ec-4445-97f6-a014bc0aa76e',
'e2fdee8c-9c3d-4c60-935e-edaa835c6381',
'20293db3-2b19-4660-9175-f6047ad5c79a',
'79912d0d-72ad-4963-b965-664839243731',
'd7e45f96-7008-4fa0-bdc5-2fd2b1e2fcaf',
'e08e07d0-6967-4785-8339-6c4a3e34da63'
  ];
}

export interface Warehouse{
  inventory_warehouse_name: string,
  inventory_warehous_uuid: string // do not change this spelling
}

export interface Response {
  total_charge: number,
  packages: Package[],
  summary: Summary
}

export interface Package{
  months_to_charge: number,
  model: string | null,
  serial: string | null,
  start_date: Date,
  total_rate: number
}

export interface Summary{
  total_amount: number,
  rate: number,
  packages_deferred: number,
  packages_previously_deferred: number,
  packages_full_month: number,
  total_packages: number,
  proration_policy: string
}

